import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { cookieConsentConfig } from 'src/app/services/cookie-consent/cookie-consent.config';
import * as CookieConsent from 'vanilla-cookieconsent';
import { Store } from '../store.service';

@Injectable({
    providedIn: 'root',
})
export class CookieConsentService {
    public constructor(private readonly cookieService: CookieService) {}

    public initialize(): Promise<void> {
        return CookieConsent.run(cookieConsentConfig);
    }

    public acceptAllCookies(): void {
        CookieConsent.acceptCategory('all');
    }

    public acceptNecessaryCookies(): void {
        CookieConsent.acceptCategory([]);
    }

    public showPreferences(): void {
        CookieConsent.showPreferences();
    }

    public isCategoryAccepted(category: string): boolean {
        return CookieConsent.acceptedCategory(category);
    }

    public setCookie(
        cookieName: string,
        cookieValue: string,
        specificPath = '/',
    ): void {
        this.cookieService.set(cookieName, cookieValue, 7, specificPath);
    }

    public deleteCookie(cookieName: string, path = '/'): void {
        this.cookieService.delete(cookieName, path);
    }

    public deleteAll(specificPath = '/'): void {
        this.cookieService.deleteAll(specificPath);
    }

    public getCookie(cookieName: string): string {
        return this.cookieService.get(cookieName);
    }

    public getAllCookies(): Record<string, string> {
        return this.cookieService.getAll();
    }

    public checkCookieExists(cookieName: string): boolean {
        return this.cookieService.check(cookieName);
    }
    public getParentCookieData(): number | null {
        let cookieData = null;
        if (Store.getDataString('ParentCookieName')) {
            cookieData = Store.getCookieData<{ patientId: number }>();
        }
        return cookieData ? cookieData.patientId : null;
    }
}
